<template>
    <div class="side-menu">
        <el-menu :router="true" :collapse="isCollapse" ref="menu">
            <template v-for="(item, index) in routes">
                <el-submenu v-if="!item.noDropdown && !item.hidden" :key="index + ''" :index="index + ''"
                            @click="$emit('clickMenu', index + '')">
                    <template slot="title">
                        <i class="fa" v-bind:class="item.icon"></i>
                        <span slot="title">
                            {{ item.title }}
                        </span>
                    </template>
                    <el-menu-item :class="{'is-active': setActive(subitem)}"
                                   :route="{path: subitem.path}"
                                  v-for="(subitem, subitemIndex) in item.children"
                                  :key="index + '' + subitemIndex"
                                  :index="index + '' + subitemIndex" :id="'menuItem' + subitem.name"
                                  @click="$emit('clickMenu', index + '' + subitemIndex)">
                        <span v-if="subitem.hidden !== true" slot="title" class="d-flex align-items-center w-100">
                           <i class="fa"></i>
                          <span slot="title" class="flex-grow-1">
                              {{ subitem.meta.title }}
                          </span>
                            <i class="el-menu-item__outer icon-external-link p-r-25" v-if="subitem.meta.outer && subitem.meta.outer === true"></i>
                        </span>
                    </el-menu-item>
                </el-submenu>
                <el-menu-item  :class="{'is-active': setActive(item)}" :route="{path: item.children[0].path}"
                               v-if="item.noDropdown && !item.hidden && (item.role === user.role || !item.role)" :key="index + ''" :index="index + ''"
                               :disabled="item.inactive"
                               @click="$emit('clickMenu', index + '')" :id="'menuItem' + item.children[0].name">
                    <i v-bind:class="item.icon || item.children[0].icon"></i>
                    <span slot="title">{{ item.title || item.children[0].meta.title }}</span>
                </el-menu-item>
            </template>
        </el-menu>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        props: ['mainMenu', 'menuChildren', 'isCollapse'],
        data () {
            return {
                parentMenuItemIndex: 0
            }
        },
        computed: {
            ...mapGetters(['user', 'routes' ]),
            year: function () {
                let date = new Date()
                return date.getFullYear()
            }
        },
        mounted () {

        },
        methods: {
            setActive (item) {
                if (this.$route.path.match(/\/\w+\/\w+\//g)) {
                    if (this.$route.path.match(/\/\w+\//g)[0].slice(0, -1) === item.path) {
                        return true
                    }
                }
                if (this.$route.path === item.path) {
                    return true
                } else return false
            }
        }
    }
</script>
